<template>
  <div class="m-ins-container">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="m-ins-card">
            <img :src="row.image1" class="img-fluid" alt="" />
            <div class="m-ins-details">
              <div class="m-ins-line-vertical" :style="{backgroundColor: `${row.lineColor1} !important`}"></div>
              <div class="bg-title mb-4 white-color" v-html="row.title1"></div>
              <router-link v-if="row.button1" :to="row.redirect1" class="m-ins-btn" v-html="row.button1"></router-link>
            </div>
            <div class="gradient-easing"></div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6">
          <div class="m-ins-card">
            <img :src="row.image2" class="img-fluid" alt="" />
            <div class="m-ins-details">
              <div class="m-ins-line-vertical" :style="{backgroundColor: `${row.lineColor2} !important`}"></div>
              <div class="bg-title mb-4 white-color" v-html="row.title2"></div>
              <router-link v-if="row.button2" :to="row.redirect2" class="m-ins-btn" v-html="row.button2"></router-link>
            </div>
            <div class="gradient-easing"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.m-ins-card {
  height: 330px;
  position: relative;
}
.m-ins-card img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.gradient-easing {
  height: 300px !important;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-image: linear-gradient( rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.00709) 10.47%, rgba(0, 0, 0, 0.02755) 19.56%, rgba(0, 0, 0, 0.06016) 27.58%, rgba(0, 0, 0, 0.1037) 34.81%, rgba(0, 0, 0, 0.15697) 41.57%, rgba(0, 0, 0, 0.21875) 48.13%, rgba(0, 0, 0, 0.28782) 54.79%, rgba(0, 0, 0, 0.36296) 61.85%, rgba(0, 0, 0, 0.44297) 69.61%, rgba(0, 0, 0, 0.52662) 78.36%, rgba(0, 0, 0, 0.6127) 88.39%, rgba(0, 0, 0, 0.7) );
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
}
.m-ins-details {
  position: absolute;
  left: 33px;
  bottom: 33px;
  z-index: 10;
}
.m-ins-line-vertical {
  height: 4px;
  width: 80px;
  margin-bottom: 10px;
}
.bg-title {
  font-size: 48px;
}
.m-ins-btn {
  border: 1px solid #fff;
  color: #fff;
  padding: 7px 20px;
  font-size: 20px;
  line-height: 1;
  display: inline-block;
}
.m-ins-btn:hover {
  background: #fff;
  color: #000;
}
.m-ins-btn:active {
  opacity: 0.6;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .m-ins-card {
    margin-bottom: 30px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .bg-title {
    font-size: 43px;
  }
  .qn-details {
    padding-top: 12px
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
